import { render, staticRenderFns } from "./end-card.vue?vue&type=template&id=3584e4e2&scoped=true&"
import script from "./end-card.vue?vue&type=script&lang=js&"
export * from "./end-card.vue?vue&type=script&lang=js&"
import style0 from "./end-card.vue?vue&type=style&index=0&id=3584e4e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3584e4e2",
  null
  
)

export default component.exports